<template>
  <div v-if="tags.length" class="article-tags">
    <div class="tags-list">
      <NuxtLink
        v-for="tag of tags"
        :key="tag.id"
        :to="`/news?tags_id=${tag.id}`"
        class="tag"
      >
        <span class="name"><span class="-green">#</span>{{ tag.name }}</span>
      </NuxtLink>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import type { ArticleTag } from '~/models/articles'

  defineProps<{
    tags: ArticleTag[]
  }>()
</script>

<style lang="scss" scoped>
  .article-tags {
    @include vp-767 {
      overflow: hidden;
    }

    > .tags-list {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;

      @include vp-767 {
        overflow: auto hidden;
        padding-bottom: 12px;
        flex-wrap: nowrap;
        width: 100%;
        max-width: calc(100vw - 32px);
        scroll-behavior: smooth;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: none;

        &::-webkit-scrollbar {
          display: none;
        }
      }
    }

    > .tags-list > .tag {
      padding: 10px 24px;
      border-radius: 40px;
      border: 1px solid $color-potato-20;
      background-color: $color-default-white;
      text-decoration: none;

      @include vp-767 {
        padding: 8px 16px;
        flex-shrink: 0;
        white-space: nowrap;
      }
    }

    > .tags-list > .tag > .name {
      font-size: 16px;
      line-height: 24px;
      color: $color-potato-90;

      @include vp-767 {
        font-size: 14px;
        line-height: 20px;
      }

      > .-green {
        font-weight: 600;
        color: $color-kiwi-50;
      }
    }
  }
</style>
